var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperlocal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5499 11.0427L9.2414 2.0401C9.28456 1.97182 9.41467 1.99611 9.41467 2.07245V7.01896C9.41467 7.27485 9.74145 7.44982 10.0419 7.35479L12.8712 6.45972C13.2616 6.3362 13.6382 6.65983 13.4501 6.95731L7.7586 15.9599C7.71544 16.0282 7.58533 16.0039 7.58533 15.9276V10.981C7.58533 10.7251 7.25855 10.5502 6.95814 10.6452L4.12881 11.5403C3.73835 11.6638 3.36183 11.3402 3.5499 11.0427Z",
    stroke: "#7737C6",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlocal);
export default __webpack_public_path__ + "static/media/hyperlocal.a1b2a4fbe34f9c4c9f3f1e7d7317d8b8.svg";
export { ForwardRef as ReactComponent };